export default {
  en: {
    copyright: 'The copyright of this event belongs to Vochat',
    toptitle: 'Room Support',
    ruleDes:
      'Make a star room and receive more rewards!<br/>Now click register button below to join the Star Room Support Program!',
    viewMyCountry: 'View room ranking of my country',
    sign: 'Register',
    back: 'Back',
    rulePop:
      "1. After register successfully, room owner and room admin can receive rewards in the next week, if the room trophy reaches the requirement in the current week;<br/>2.From every Monday to every Tuesday, it is review time for the last week rewards. Rewards will be issued automatically after review;<br/>3. Room owner can edit reward list of the current week before 12:00 midnight every Sunday. When it gets to review status, no edit is allowed;<br/>4.Up to 10 award candidates can be added for every room. The rewards will be given according to the order they are added (If room  reward is in level 2, admins of No1, 2 and 3 can receive rewards;<br/>5.Wealth level of the award candidate should ≥ level 10 and, every user can only become award candidate of one room.<br/>6. Room owner can choose to receive owner rewards from his own room or receive admin rewards from other people's room.<br/>7. If the registered room fails to meet the minimum requirement  for 2 consecutive weeks, its registration will be automatically cancelled. ",
    rule: 'Rules',
    ruleTitle: 'Star room support rule',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    super: 'Super Star Room Honor',
    register: 'Register',
    registerTxt: 'You can register when room trophy≥50k this week and room popularity>90',
    SupportRewards: 'Support rewards',
    HonorRewards: 'Honor rewards',
    HonorRewardsTxt:
      'Rooms reaching super star room requirements can receive 7-day room medal and room owner can have the 7-day headwear for star room owner.',
    HonorRewardsTxt2: '(Honor rewards and support rewards will be issued at the same time)',
    RoomRewards: 'Room Rewards',
    Level: 'Level',
    roomPopularity: 'room popularity',
    WeeklyRoomTrophy: 'Weekly Room Trophy',
    WeeklySupport: 'Weekly Support',
    TotalSupport: 'Total Support',
    Bonus: 'Super Bonus For Room Owner!',
    Famous: 'Famous Room Rewards',
    service: 'If you have questions, please click here to contact customer service.',
    rwt: 'Room Weekly Trophy',
    rm: 'Room Medal (7 Days)',
    setTest: 'This event has ended'
  },
  ar: {
    copyright: 'يتمتع الفوشات بحق الشرح النهائي',
    toptitle: 'دعم الغرفة',
    ruleDes:
      'قم بإنشاء غرفة واحصل على المزيد من المكافآت انقر الآن على زر التسجيل أدناه للانضمام إلى برنامج دعم الغرفة',
    viewMyCountry: 'نطر في تصنيف غرف بلدك',
    sign: 'تسجيل',
    back: 'عاد إلى الصفحة الماضية',
    rulePop:
      '١.بعد تسجيل بنجاح، يمكن لصاحب الغرفة وأدمن الغرفة تلقي مكافآت الدعم في الأسبوع التالي عندما يصل تعزيز كؤوس الغرفة هذا الأسبوع إلى الهدف المحدد<br/> ٢.كل يوم إثنين ويوم ثلاثاء وقت التحقق للمكافآت الأسبوعية الماضية، بعد التحقق سنزل المكافآت بتلقاني<br/> ٣. يمكن لصاحب الغرفة تعديل قائمة مستلمي الدعم لهذا الأسبوع قبل الساعة 12 مساء كل يوم أحد. لا يتم تحرير فترة المراجعة بعد أن تبدأ<br/> ٤.يمكن لكل غرفة ترتيب 10 مرشحين مدعومين كحد أقصى. سيتم تقديم الدعم حسب رتبة المرشح. (على سبيل المثال ، إذا كان مستوى دعم الغرفة هو 2 ، فإن المشرف الأول والثاني والثالث في القائمة سيتلقى الدعم)<br/> ٥.المرشح المدعومي يجب أن يكون مستوى الثروة 10 وما فوق. ويمكن لكل مستخدم أن يكون مرشحًا  لغرفة واحدة فقط<br/> ٦.يمكن لصاحب الغرفة الحصول على الدعم لصاحب الغرفة في غرفته. أو ، بدلاً من ذلك ، يمكن الحصول على دعم الأدمن في الغرفة الأخرى<br/> ٧.إذا لم تصل الغرفة المسجلة إلى 100 ألف لمدة أسبوعين متتاليين ، فسيتم إلغاء التسجيل تلقائيًا.',
    rule: 'القواعد',
    ruleTitle: 'قواعد الدعم لغرفة النجوم',
    thisWeek: 'هذا الأسبوع',
    lastWeek: 'الأسبوع الماضي',
    super: 'الشرف لسوبرغرفة النجوم',
    register: 'تسجيل',
    registerTxt: '90',
    SupportRewards: 'مكافآت الدعم',
    HonorRewards: 'مكافآت الشرف',
    HonorRewardsTxt:
      'تصل الغرفة إلى مستوى سوبر غرفة النجوم فاستلام بشارة الغرفة لمدة 7 الأيام، الصاحب يمكن الحصول على إيطار صاحب النجوم لمدة 7 الأيام',
    HonorRewardsTxt2: 'نزلت مكافآت الشرف ومكافآت الدعم في نفس الوقت',
    RoomRewards: 'مكافأة الغرف',
    Level: 'المستوى',
    roomPopularity: 'شعبية الغرفة',
    WeeklyRoomTrophy: 'كأس الغرفة الاسبوعي',
    WeeklySupport: 'الدعم الأسبوعي',
    TotalSupport: 'الدعم الإجمالي',
    Bonus: 'مكافأة رائعة لصاحب الغرفة!',
    Famous: 'مكافآت الغرف المشهورة',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',
    setTest: 'تم  انتهاء الحدث',
    rwt: 'الكأس الأسبوعي للغرفة',
    rm: 'ميدالية الغرفة (7 أيام'
  },
  tr: {
    copyright: "Etkinliği yorumlama hakkı VoChat'e aittir.",
    toptitle: 'Oda Desteği',
    ruleDes: `Bir oda oluşturun ve daha fazla ödül kazanın!
Şimdi Yıldız Oda Destek tablosundan yararlanmak için odanızda atış yapın ve aşağıdaki “Kayıt Ol” Butonuna tıklayın.`,
    viewMyCountry: 'Kendi ülkenin oda sıralamasına bak',
    sign: 'Kayıt Ol',
    back: 'Geri dön',
    setTest: 'Etkinlik bitti',
    rulePop:
      "1. Başarıyla kayıt olduktan sonra bu haftaki oda kupa artışı belirli hedefe ulaştığında oda sahibi ve oda aminleri bir sonraki hafta destek ödülleri alabilir.<br/>2. Her pazartesi ve salı günü bir önceki haftaki ödülleri inceleme süresidir. İnceleme bittikten sonra ödüller otomatik olarak teslim edilecek.<br/>3. Oda sahibi her pazar günü akşam saat 12'den önce bu haftaki destek alanlar listesini düzenleyebilir. İnceleme süresi başladıktan sonra düzenlenmez.<br/>4. Her oda en çok 10 destek alan adayı ayarlayabilir. Destek aday sıralamasına göre verilecek. (Örneğin, oda destek seviyesi 2 ise listedeki 1., 2., 3. admin destek alacak)<br/>5. Destek alan adayı olmak için servet seviyesi 10 ve üstü olmalı. Ve her kullanıcı tek bir odanın destek alan adayı olabilir.<br/>6. Oda sahibi kendi odadaki oda sahibi desteği alabilir. Ya da bunun yerine başkası odasındaki admin desteği alabilir.<br/>7. Eğer kayıt olan oda art arda 2 hafta kupa artışı 100k'e ulaşmasa kaydı otomatik olarak iptal edilecek.",
    rule: 'Kural',
    ruleTitle: 'Yıldız oda destek kuralı',
    thisWeek: 'Bu hafta',
    lastWeek: 'Geçen hafta',
    super: 'Süper Yıldız Oda Onuru',
    register: 'Kayıt Ol',
    registerTxt: "Bu haftaki oda kupa artışı 50k'ya, oda popülerliği 90'e ulaştığında kayıt olabilirsiniz.",
    SupportRewards: 'Destek ödülleri',
    HonorRewards: 'Onur Ödülü',
    HonorRewardsTxt:
      'Süper Yıldız Oda şartlarını karşılayan oda 7 günlük oda rozeti, oda sahibi 7 günlük yıldız oda sahibi çerçevesi alacak.',
    HonorRewardsTxt2: '(Onur ödülü destekle birlikte teslim edilecek)',
    RoomRewards: 'Room Rewards',
    Level: 'Level',
    roomPopularity: 'room popularity',
    WeeklyRoomTrophy: 'Weekly Room Trophy',
    WeeklySupport: 'Weekly Support',
    TotalSupport: 'Total Support',
    Bonus: 'Super Bonus For Room Owner!',
    Famous: 'Famous Room Rewards',
    service: 'Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın',

    rwt: 'Oda Haftalık Ödülü',
    rm: 'Oda Madalyası (7 Gün)'
  },
  pt: {
    copyright: 'Os direitos autorais deste evento pertencem à Vochat',
    toptitle: 'Suporte de Sala',
    ruleDes:
      'Crie uma sala estrela e receba mais recompensas!<br/>Agora clique no botão de registro abaixo para se inscrever no Programa de Suporte da Sala Estrela!',
    viewMyCountry: 'Ver ranking da sala do meu país',
    sign: 'Registrar',
    back: 'Voltar',
    rulePop:
      '1. Após o registro bem-sucedido, o proprietário da sala e o administrador da sala podem receber recompensas na próxima semana, se o troféu da sala atingir o requisito na semana atual;<br/>2. De toda segunda-feira a terça-feira, é o tempo de revisão para as recompensas da última semana. As recompensas serão emitidas automaticamente após a revisão;<br/>3. O proprietário da sala pode editar a lista de recompensas da semana atual antes das 12:00 da meia-noite de todo domingo. Quando entrar em status de revisão, não será permitido editar;<br/>4. Até 10 candidatos a prêmios podem ser adicionados para cada sala. As recompensas serão dadas de acordo com a ordem em que foram adicionados (Se a recompensa da sala estiver no nível 2, os administradores da sala No1, 2 e 3 podem receber recompensas;<br/>5. O nível de riqueza do candidato a prêmio deve ser ≥ nível 10 e, cada usuário pode ser candidato a prêmio de apenas uma sala.<br/>6. O proprietário da sala pode escolher receber recompensas de proprietário da sua própria sala ou recompensas de administrador de outra sala.<br/>7. Se a sala registrada não atender ao requisito mínimo por 2 semanas consecutivas, seu registro será automaticamente cancelado.',
    rule: 'Regras',
    ruleTitle: 'Regras do suporte da sala estrela',
    thisWeek: 'Esta semana',
    lastWeek: 'Semana passada',
    super: 'Honra da Sala Estrela Super',
    register: 'Registrar',
    registerTxt: 'Você pode se registrar quando o troféu da sala ≥ 50k esta semana e a popularidade da sala > 90',
    SupportRewards: 'Recompensas de Suporte',
    HonorRewards: 'Recompensas de Honra',
    HonorRewardsTxt:
      'As salas que atingirem os requisitos de sala estrela super podem receber a medalha da sala por 7 dias e o proprietário da sala pode ter o chapéu de 7 dias para proprietário de sala estrela.',
    HonorRewardsTxt2: '(As recompensas de honra e suporte serão emitidas ao mesmo tempo)',
    RoomRewards: 'Recompensas da Sala',
    Level: 'Nível',
    roomPopularity: 'Popularidade da sala',
    WeeklyRoomTrophy: 'Troféu Semanal da Sala',
    WeeklySupport: 'Suporte Semanal',
    TotalSupport: 'Suporte Total',
    Bonus: 'Super Bônus para o Proprietário da Sala!',
    Famous: 'Recompensas de Sala Famosa',
    service: 'Se você tiver dúvidas, clique aqui para entrar em contato com o suporte ao cliente.',
    rwt: 'Troféu Semanal da Sala',
    rm: 'Medalha da Sala (7 Dias)',
    setTest: 'Este evento foi encerrado'
  },
  id: {
    copyright: 'Hak cipta acara ini milik Vochat',
    toptitle: 'Dukungan Ruang',
    ruleDes:
      'Buat ruang bintang dan dapatkan lebih banyak hadiah!<br/>Sekarang klik tombol daftar di bawah untuk bergabung dengan Program Dukungan Ruang Bintang!',
    viewMyCountry: 'Lihat peringkat ruang negara saya',
    sign: 'Daftar',
    back: 'Kembali',
    rulePop:
      '1. Setelah berhasil mendaftar, pemilik ruang dan admin ruang dapat menerima hadiah di minggu berikutnya, jika trofi ruang memenuhi syarat di minggu ini;<br/>2. Setiap Senin hingga Selasa, adalah waktu peninjauan untuk hadiah minggu lalu. Hadiah akan diberikan secara otomatis setelah peninjauan;<br/>3. Pemilik ruang dapat mengedit daftar hadiah minggu ini sebelum pukul 12:00 tengah malam setiap hari Minggu. Ketika sudah masuk status peninjauan, pengeditan tidak diperbolehkan;<br/>4. Hingga 10 calon penerima hadiah dapat ditambahkan untuk setiap ruang. Hadiah akan diberikan sesuai dengan urutan penambahannya (Jika hadiah ruang berada di level 2, admin ruang No1, 2, dan 3 dapat menerima hadiah;<br/>5. Level kekayaan calon penerima hadiah harus ≥ level 10, dan setiap pengguna hanya dapat menjadi calon penerima hadiah untuk satu ruang.<br/>6. Pemilik ruang dapat memilih untuk menerima hadiah pemilik dari ruangnya sendiri atau menerima hadiah admin dari ruang orang lain.<br/>7. Jika ruang yang terdaftar gagal memenuhi persyaratan minimum selama 2 minggu berturut-turut, pendaftarannya akan dibatalkan secara otomatis.',
    rule: 'Aturan',
    ruleTitle: 'Aturan dukungan ruang bintang',
    thisWeek: 'Minggu ini',
    lastWeek: 'Minggu lalu',
    super: 'Penghargaan Ruang Bintang Super',
    register: 'Daftar',
    registerTxt: 'Anda dapat mendaftar ketika trofi ruang ≥50k minggu ini dan popularitas ruang >90',
    SupportRewards: 'Hadiah Dukungan',
    HonorRewards: 'Hadiah Kehormatan',
    HonorRewardsTxt:
      'Ruang yang mencapai persyaratan ruang bintang super dapat menerima medali ruang selama 7 hari dan pemilik ruang dapat memiliki aksesori kepala selama 7 hari untuk pemilik ruang bintang.',
    HonorRewardsTxt2: '(Hadiah Kehormatan dan Hadiah Dukungan akan diberikan sekaligus)',
    RoomRewards: 'Hadiah Ruang',
    Level: 'Level',
    roomPopularity: 'Popularitas ruang',
    WeeklyRoomTrophy: 'Trofi Ruang Mingguan',
    WeeklySupport: 'Dukungan Mingguan',
    TotalSupport: 'Dukungan Total',
    Bonus: 'Bonus Super Untuk Pemilik Ruang!',
    Famous: 'Hadiah Ruang Terkenal',
    service: 'Jika Anda memiliki pertanyaan, silakan klik di sini untuk menghubungi layanan pelanggan.',
    rwt: 'Trofi Ruang Mingguan',
    rm: 'Medali Ruang (7 Hari)',
    setTest: 'Acara ini telah berakhir'
  },
  uz: {
    copyright: "Ushbu tadbirning mualliflik huquqi Vochat'ga tegishli",
    toptitle: 'Xonani qo‘llab-quvvatlash',
    ruleDes:
      'Yulduz xonani yarating va ko‘proq mukofotlarga ega bo‘ling!<br/>Endi quyidagi ro‘yxatdan o‘tish tugmasini bosib, Yulduz Xonani Qo‘llab-quvvatlash Dasturiga qo‘shiling!',
    viewMyCountry: 'Mening mamlakatimning xona reytingini ko‘rish',
    sign: 'Ro‘yxatdan o‘tish',
    back: 'Orqaga',
    rulePop:
      '1. Ro‘yxatdan muvaffaqiyatli o‘tgandan so‘ng, agar xona kubogi joriy haftada talabga javob bersa, xona egasi va administrator keyingi hafta mukofot olishi mumkin;<br/>2. Har dushanbadan seshanbagacha, o‘tgan haftaning mukofotlari ko‘rib chiqiladi. Tekshirish tugagach, mukofotlar avtomatik ravishda beriladi;<br/>3. Xona egasi har yakshanba kuni soat 12:00gacha joriy haftaning mukofot ro‘yxatini tahrirlashi mumkin. Agar tekshirish bosqichiga o‘tsa, o‘zgartirishga ruxsat berilmaydi;<br/>4. Har bir xona uchun 10 tagacha mukofot oluvchi qo‘shilishi mumkin. Mukofotlar qo‘shilgan tartib bo‘yicha beriladi (Agar xona mukofoti 2-darajada bo‘lsa, 1, 2 va 3-chi administratorlar mukofot olishlari mumkin);<br/>5. Mukofot oluvchining boylik darajasi ≥ 10 bo‘lishi kerak va har bir foydalanuvchi faqat bitta xona mukofot oluvchisi bo‘lishi mumkin.<br/>6. Xona egasi o‘z xonasidan egasi sifatida mukofot olish yoki boshqa birovning xonasidan administrator mukofotini olishni tanlashi mumkin.<br/>7. Agar ro‘yxatdan o‘tgan xona ketma-ket 2 hafta minimal talabga javob bermasa, uning ro‘yxati avtomatik ravishda bekor qilinadi.',
    rule: 'Qoidalar',
    ruleTitle: 'Yulduz Xonani Qo‘llab-quvvatlash Qoidalari',
    thisWeek: 'Bu hafta',
    lastWeek: 'O‘tgan hafta',
    super: 'Super Yulduz Xona Sharafi',
    register: 'Ro‘yxatdan o‘tish',
    registerTxt: 'Agar bu hafta xona kubogi ≥ 50k va xona mashhurligi > 90 bo‘lsa, siz ro‘yxatdan o‘tishingiz mumkin',
    SupportRewards: 'Qo‘llab-quvvatlash mukofotlari',
    HonorRewards: 'Sharaf mukofotlari',
    HonorRewardsTxt:
      'Super yulduz xona talablariga javob beradigan xonalar 7 kunlik xona medali oladi va xona egasi 7 kunlik yulduz xona egasi bosh kiyimiga ega bo‘ladi.',
    HonorRewardsTxt2: '(Sharaf mukofotlari va qo‘llab-quvvatlash mukofotlari bir vaqtda beriladi)',
    RoomRewards: 'Xona mukofotlari',
    Level: 'Daraja',
    roomPopularity: 'Xona mashhurligi',
    WeeklyRoomTrophy: 'Haftalik Xona Kubogi',
    WeeklySupport: 'Haftalik Qo‘llab-quvvatlash',
    TotalSupport: 'Jami Qo‘llab-quvvatlash',
    Bonus: 'Xona Egasi uchun Super Bonus!',
    Famous: 'Mashhur Xona Mukofotlari',
    service: 'Agar savollaringiz bo‘lsa, mijozlarga xizmat ko‘rsatish bilan bog‘lanish uchun shu yerni bosing.',
    rwt: 'Xonaning Haftalik Kubogi',
    rm: 'Xona Medali (7 Kun)',
    setTest: 'Ushbu tadbir yakunlandi'
  },
  ru: {
    copyright: 'Авторские права на это мероприятие принадлежат Vochat',
    toptitle: 'Поддержка комнаты',
    ruleDes:
      'Создайте звездную комнату и получайте больше наград!<br/>Нажмите кнопку регистрации ниже, чтобы присоединиться к программе поддержки звездной комнаты!',
    viewMyCountry: 'Посмотреть рейтинг комнат в моей стране',
    sign: 'Регистрация',
    back: 'Назад',
    rulePop:
      '1. После успешной регистрации владелец комнаты и администраторы могут получать награды на следующей неделе, если трофей комнаты соответствует требованиям на текущей неделе;<br/>2. С понедельника по вторник проходит проверка наград за прошлую неделю. Награды выдаются автоматически после проверки;<br/>3. Владелец комнаты может редактировать список наград текущей недели до 12:00 ночи в воскресенье. После перехода в статус проверки редактирование невозможно;<br/>4. В каждую комнату можно добавить до 10 претендентов на награды. Награды будут выдаваться в порядке их добавления (Если награда за комнату уровня 2, награды могут получить администраторы №1, 2 и 3);<br/>5. Уровень богатства претендента на награду должен быть ≥ 10, и каждый пользователь может быть претендентом только в одной комнате.<br/>6. Владелец комнаты может выбрать получение награды владельца из своей комнаты или награды администратора из чужой комнаты.<br/>7. Если зарегистрированная комната не соответствует минимальному требованию в течение 2 недель подряд, её регистрация будет автоматически отменена.',
    rule: 'Правила',
    ruleTitle: 'Правила поддержки звездной комнаты',
    thisWeek: 'На этой неделе',
    lastWeek: 'На прошлой неделе',
    super: 'Почет звёздной комнаты',
    register: 'Регистрация',
    registerTxt: 'Вы можете зарегистрироваться, если на этой неделе трофей комнаты ≥ 50k, а популярность комнаты > 90',
    SupportRewards: 'Награды за поддержку',
    HonorRewards: 'Почетные награды',
    HonorRewardsTxt:
      'Комнаты, достигшие уровня суперзвезды, могут получить 7-дневную медаль комнаты, а владелец комнаты – 7-дневный головной убор владельца звездной комнаты.',
    HonorRewardsTxt2: '(Почетные и поддерживающие награды выдаются одновременно)',
    RoomRewards: 'Награды комнаты',
    Level: 'Уровень',
    roomPopularity: 'Популярность комнаты',
    WeeklyRoomTrophy: 'Еженедельный трофей комнаты',
    WeeklySupport: 'Еженедельная поддержка',
    TotalSupport: 'Общая поддержка',
    Bonus: 'Супер бонус для владельца комнаты!',
    Famous: 'Награды за известную комнату',
    service: 'Если у вас есть вопросы, нажмите здесь, чтобы связаться со службой поддержки.',
    rwt: 'Еженедельный трофей комнаты',
    rm: 'Медаль комнаты (7 дней)',
    setTest: 'Это мероприятие завершено'
  },
  fa: {
    copyright: 'حق چاپ این رویداد متعلق به Vochat است',
    toptitle: 'پشتیبانی اتاق',
    ruleDes:
      'یک اتاق ستاره بسازید و جوایز بیشتری دریافت کنید!<br/>اکنون روی دکمه ثبت‌نام زیر کلیک کنید تا به برنامه پشتیبانی اتاق ستاره بپیوندید!',
    viewMyCountry: 'مشاهده رتبه‌بندی اتاق کشور من',
    sign: 'ثبت نام',
    back: 'بازگشت',
    rulePop:
      '۱. پس از ثبت‌نام موفق، مالک اتاق و مدیر اتاق می‌توانند در هفته بعد پاداش دریافت کنند، اگر جام اتاق در هفته جاری به حد نصاب برسد؛<br/>۲. از دوشنبه تا سه‌شنبه هر هفته، زمان بررسی جوایز هفته گذشته است. جوایز پس از بررسی به‌طور خودکار صادر خواهند شد؛<br/>۳. مالک اتاق می‌تواند فهرست جوایز هفته جاری را تا قبل از ساعت ۱۲ شب یکشنبه ویرایش کند. پس از ورود به وضعیت بررسی، ویرایش امکان‌پذیر نیست؛<br/>۴. حداکثر ۱۰ نامزد جایزه می‌توانند برای هر اتاق اضافه شوند. جوایز بر اساس ترتیب اضافه شدن آن‌ها توزیع می‌شود (اگر پاداش اتاق در سطح ۲ باشد، مدیران شماره ۱، ۲ و ۳ می‌توانند جوایز دریافت کنند)؛<br/>۵. سطح ثروت نامزد جایزه باید حداقل سطح ۱۰ باشد و هر کاربر فقط می‌تواند نامزد دریافت جایزه یک اتاق باشد؛<br/>۶. مالک اتاق می‌تواند انتخاب کند که پاداش مالک را از اتاق خود دریافت کند یا پاداش مدیر را از اتاق‌های دیگر دریافت نماید؛<br/>۷. اگر اتاق ثبت‌شده به مدت ۲ هفته متوالی حداقل الزامات را برآورده نکند، ثبت‌نام آن به‌طور خودکار لغو خواهد شد.',
    rule: 'قوانین',
    ruleTitle: 'قوانین پشتیبانی اتاق ستاره',
    thisWeek: 'این هفته',
    lastWeek: 'هفته گذشته',
    super: 'افتخار اتاق ستاره فوق‌العاده',
    register: 'ثبت نام',
    registerTxt: 'شما می‌توانید زمانی ثبت‌نام کنید که جام اتاق این هفته ≥۵۰k و محبوبیت اتاق >۹۰ باشد',
    SupportRewards: 'جوایز پشتیبانی',
    HonorRewards: 'جوایز افتخار',
    HonorRewardsTxt:
      'اتاق‌هایی که شرایط اتاق ستاره فوق‌العاده را دارند می‌توانند مدال ۷ روزه اتاق دریافت کنند و مالک اتاق نیز می‌تواند تاج ۷ روزه مالک اتاق ستاره را داشته باشد.',
    HonorRewardsTxt2: '(جوایز افتخار و جوایز پشتیبانی به‌طور هم‌زمان صادر خواهند شد)',
    RoomRewards: 'جوایز اتاق',
    Level: 'سطح',
    roomPopularity: 'محبوبیت اتاق',
    WeeklyRoomTrophy: 'جام هفتگی اتاق',
    WeeklySupport: 'پشتیبانی هفتگی',
    TotalSupport: 'پشتیبانی کلی',
    Bonus: 'پاداش ویژه برای مالک اتاق!',
    Famous: 'جوایز اتاق مشهور',
    service: 'اگر سوالی دارید، لطفاً اینجا کلیک کنید تا با پشتیبانی مشتری تماس بگیرید.',
    rwt: 'جام هفتگی اتاق',
    rm: 'مدال اتاق (۷ روز)',
    setTest: 'این رویداد به پایان رسیده است'
  },
  ur: {
    copyright: 'اس ایونٹ کا جملہ حقوق وو چیٹ کے پاس محفوظ ہیں',
    toptitle: 'کمرہ معاونت',
    ruleDes:
      'ایک اسٹار روم بنائیں اور مزید انعامات حاصل کریں!<br/>اب اسٹار روم سپورٹ پروگرام میں شامل ہونے کے لئے نیچے رجسٹر بٹن پر کلک کریں!',
    viewMyCountry: 'میرے ملک کی کمرہ درجہ بندی دیکھیں',
    sign: 'رجسٹر کریں',
    back: 'واپس',
    rulePop:
      '1. کامیابی سے رجسٹریشن کے بعد، اگر موجودہ ہفتے میں کمرہ ٹرافی مطلوبہ معیار تک پہنچتی ہے تو کمرہ مالک اور منتظم اگلے ہفتے میں انعامات حاصل کر سکتے ہیں;<br/>2. ہر پیر سے منگل تک، یہ گزشتہ ہفتے کے انعامات کا جائزہ لینے کا وقت ہے۔ جائزہ لینے کے بعد انعامات خود بخود جاری کیے جائیں گے;<br/>3. کمرہ مالک اتوار کی رات 12:00 بجے سے پہلے موجودہ ہفتے کے انعامات کی فہرست میں ترمیم کرسکتا ہے۔ جب جائزہ لینے کا مرحلہ شروع ہوتا ہے تو ترمیم کی اجازت نہیں ہے;<br/>4. ہر کمرے میں زیادہ سے زیادہ 10 انعامی امیدوار شامل کیے جا سکتے ہیں۔ انعامات اس ترتیب کے مطابق دیئے جائیں گے جس میں انہیں شامل کیا گیا تھا (اگر کمرہ انعامی سطح 2 پر ہے، تو نمبر 1، 2 اور 3 کے منتظمین انعامات حاصل کر سکتے ہیں);<br/>5. انعامی امیدوار کی دولت کی سطح کم از کم 10 ہونی چاہئے اور ہر صارف صرف ایک کمرہ کا انعامی امیدوار بن سکتا ہے;<br/>6. کمرہ مالک اپنا انعام اپنے کمرے سے یا دوسرے افراد کے کمرے سے منتظم انعام کے طور پر منتخب کر سکتا ہے;<br/>7. اگر رجسٹر شدہ کمرہ 2 مسلسل ہفتوں تک کم از کم معیار کو پورا کرنے میں ناکام رہتا ہے، تو اس کی رجسٹریشن خود بخود منسوخ کر دی جائے گی۔',
    rule: 'قواعد',
    ruleTitle: 'اسٹار روم سپورٹ کے قواعد',
    thisWeek: 'اس ہفتہ',
    lastWeek: 'پچھلا ہفتہ',
    super: 'سپر اسٹار روم اعزاز',
    register: 'رجسٹر کریں',
    registerTxt: 'آپ اس ہفتے اس وقت رجسٹر کر سکتے ہیں جب کمرہ ٹرافی ≥50k ہو اور کمرہ کی مقبولیت >90 ہو',
    SupportRewards: 'سپورٹ انعامات',
    HonorRewards: 'اعزازی انعامات',
    HonorRewardsTxt:
      'وہ کمرے جو سپر اسٹار روم کے معیار تک پہنچتے ہیں وہ 7 دن کی کمرہ میڈل حاصل کر سکتے ہیں اور کمرہ مالک کے لیے 7 دن کا اسٹار روم ہیڈ ویئر دستیاب ہوگا۔',
    HonorRewardsTxt2: '(اعزازی انعامات اور سپورٹ انعامات ایک ہی وقت میں جاری کیے جائیں گے)',
    RoomRewards: 'کمرہ انعامات',
    Level: 'سطح',
    roomPopularity: 'کمرہ کی مقبولیت',
    WeeklyRoomTrophy: 'ہفتہ وار کمرہ ٹرافی',
    WeeklySupport: 'ہفتہ وار سپورٹ',
    TotalSupport: 'کل سپورٹ',
    Bonus: 'کمرہ مالک کے لیے سپر بونس!',
    Famous: 'مشہور کمرہ انعامات',
    service: 'اگر آپ کے پاس کوئی سوالات ہیں، تو براہ کرم یہاں کلک کریں اور کسٹمر سروس سے رابطہ کریں۔',
    rwt: 'ہفتہ وار کمرہ ٹرافی',
    rm: 'کمرہ میڈل (7 دن)',
    setTest: 'یہ ایونٹ ختم ہو چکا ہے'
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/lang.js